import axios from "axios";

// Create an Axios instance with your portal backend base URL
const api = axios.create({
  baseURL: "https://portal-backend-885787520862.europe-west1.run.app",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add a request interceptor to include the token in the Authorization header
api.interceptors.request.use(
  (config) => {
    // Get the stored session from sessionStorage
    const storedSession = sessionStorage.getItem("iz_portal_session");
    if (storedSession) {
      try {
        const session = JSON.parse(storedSession);
        if (session.token) {
          config.headers.Authorization = `Bearer ${session.token}`;
        }
      } catch (error) {
        console.error("Error parsing stored session:", error);
      }
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - clear session and redirect to login
      sessionStorage.removeItem("iz_portal_session");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;